export default __webpack_public_path__ + "static/media/img-about-full-circle-economy-min.983a7e75.png";